import Vue from 'vue';
import {Pagination, Keyboard, A11y} from "swiper/modules";

export default (el) =>
  new Vue({
    components: {
      'vue-image': () => import('../vue-image/vue-image.vue'),
      'vue-swiper': () => import('../vue-swiper/vue-swiper.vue'),
      'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
    },
    el,
    data() {
      return {
        swiperOptions: {
          slidesPerView: 1.8,
          centeredSlides: true,
          loop: true,
          keyboard: true,
          a11y: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
              return `<button class="${className}"></button>`;
            }
          },
          modules: [Pagination, A11y, Keyboard]
        }
      };
    },
    mounted() {},
    computed: {},
    methods: {},
  });
